import React from 'react';
import PropTypes from 'prop-types';

import Result from './Result';
import Pagination from '../../../components/react/Pagination';

const ResultsListing = ({
  feed,
  page,
  resultsCount,
  resultsPerPage,
  noResultsLabel,
  onPaginate
}) => {
  if (!resultsCount) {
    return <p>{noResultsLabel}</p>;
  }

  return (
    <>
      {feed.map(newsItem => (
        <Result key={newsItem.id} {...newsItem} />
      ))}
      {resultsCount > resultsPerPage && (
        <Pagination
          currentPage={page}
          totalPages={Math.ceil(resultsCount / resultsPerPage)}
          onNavigate={page => onPaginate(page)}
        />
      )}
    </>
  );
};

ResultsListing.propTypes = {
  feed: PropTypes.array,
  page: PropTypes.number,
  resultsCount: PropTypes.number,
  resultsPerPage: PropTypes.number,
  noResultsLabel: PropTypes.string.isRequired,
  onPaginate: PropTypes.func.isRequired
};

export default ResultsListing;
